import { Phone, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "../../data/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t-2 border-[#1A1A1A] bg-[#FDFBF7]"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-4 py-12 md:flex-row md:items-center md:px-8">
        <div>
          <img
            src="/assets/logo.png"
            alt="Deny's Burger & Fries logosu"
            className="h-14 w-auto"
          />
          <p className="mt-3 text-sm font-bold uppercase tracking-wide text-[#4A4A4A]">
            Lezzet her zaman kazanır.
          </p>
        </div>
        <div className="flex flex-col gap-3 text-sm font-bold uppercase tracking-wide">
          <a
            data-testid="footer-phone-link"
            href={SITE.phoneUrl}
            className="flex items-center gap-2 text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            <Phone size={16} strokeWidth={2.5} /> {SITE.phoneDisplay}
          </a>
          <a
            data-testid="footer-instagram-link"
            href={SITE.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#1A1A1A] transition-colors hover:text-[#E63946]"
          >
            <Instagram size={16} strokeWidth={2.5} /> @denysburger
          </a>
          <a
            data-testid="footer-whatsapp-link"
            href={SITE.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#25D366] transition-colors hover:text-[#128C7E]"
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
              <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.03c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 4.54 0 8.24 3.7 8.24 8.24 0 4.55-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.27z"/>
            </svg>
            WhatsApp
          </a>
        </div>
      </div>
      <div className="border-t-2 border-[#1A1A1A] py-4 text-center text-xs font-medium uppercase tracking-widest text-[#4A4A4A]">
        <Link
          to="/giris"
          data-testid="footer-hidden-login-link"
          className="cursor-default no-underline"
          aria-label="Yönetim girişi"
        >
          ©
        </Link>{" "}
        {new Date().getFullYear()} Deny's Burger & Fries
      </div>
    </footer>
  );
};
